import i18n from '@/i18n';

export default (value) => {
  if (!value) return '';
  return value.toLocaleString(`${i18n.locale}-CA`, { style: 'currency', currency: 'CAD' });
};
